module.exports = __webpack_public_path__ + "img/p2.276354df.png";